// extracted by mini-css-extract-plugin
module.exports = {"paddingSmall":"styles-module--paddingSmall--2e71x","paddingMedium":"styles-module--paddingMedium--3r3wL","paddingLarge":"styles-module--paddingLarge--2FDG8"};